<template>
  <v-container class="fill-height" fluid flat>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="5" md="4" lg="3">
        <v-card>
          <v-card-title primary-title>
            <v-spacer></v-spacer>
            WindReports
            <v-spacer></v-spacer>
          </v-card-title>

          <v-card-text>
            <v-window v-model="state">
              <v-window-item>
                <v-form ref="form" lazy-validation>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="Nombre de usuario"
                        name="username"
                        prepend-icon
                        type="text"
                        :rules="usernameRules"
                        v-model="username"
                        outlined
                        @keyup.enter="handleSubmit($event)"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        label="Contraseña"
                        name="password"
                        :type="show1 ? 'text' : 'password'"
                        :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                        aria-valuemin="4"
                        :rules="[ v => !!v||'Requerido']"
                        v-model="password"
                        outlined
                        required
                        @click:append="show1 = !show1"
                        @keyup.enter="handleSubmit($event)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row align="center" justify="center">
                    <router-link to="recuperar">¿Has olvidado tu contraseña?</router-link>
                  </v-row>
                </v-form>
              </v-window-item>

              <v-window-item>
                <v-form ref="update" lazy-validation>
                  <v-row>
                    <v-col cols="12">
                      <h2 class="title mb-4">El usuario necesita cambiar la contraseña.</h2>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        label="Nombre de usuario"
                        name="username"
                        prepend-icon
                        type="text"
                        :rules="usernameRules"
                        v-model="username"
                        disabled
                        outlined
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        label="Nueva contraseña"
                        name="password"
                        prepend-icon
                        type="password"
                        :rules="[ v => !!v||'Requerido']"
                        v-model="password_new"
                        outlined
                        required
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        id="password"
                        label="Repita nueva contraseña"
                        name="password"
                        prepend-icon
                        type="password"
                        :rules="[checkPass]"
                        v-model="password_new_retype"
                        outlined
                        required
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-form>
              </v-window-item>
            </v-window>
          </v-card-text>

          <v-card-actions class="pt-0 pa-4">
            <v-btn
              color="primary"
              depressed
              block
              :loading="loading"
              :disabled="loading"
              @click="submit($event)"
            >{{ buttonText }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { AuthClient } from "@/api/AuthClient";

export default {
  props: {},
  data: () => ({
    show1: false,
    drawer: null,
    username: null,
    password: null,
    password_new: "",
    password_new_retype: null,
    loading: false,
    errorLogin: 0,
    usernameRules: [v => !!v || "Requerido"],
    confirmPassRules: [
      v => !!v || "Requerido",
      () => this.password_new === undefined || "Introduce contraseña",
      v => v !== this.password_new || "Contraseña diferente"
    ],
    state: 0
  }),
  computed: {
    buttonText () {
      return this.state === 0 ? 'Acceder' : 'Enviar'
    }
  },
  methods: {
    submit(event) {
      this.state === 0 ? this.handleSubmit(event) : this.submitUpdate(event)
    },
    handleSubmit(e) {
      e.preventDefault();
      if (this.$refs.form.validate()) {
        this.loading = true;
        AuthClient.login(this.username, this.password)
          .then(resp => {
            console.log("🚀 ~ file: Login.vue ~ line 157 ~ handleSubmit ~ resp", resp)
            this.loading = false;
            if (resp.data.token == undefined) {
              //user need update password
              this.state = 1;
            } else {
              AuthClient.saveUser({
                token: resp.data.token,
                username: this.username,
                roles: resp.data.roles
              });
              this.$store.commit('loadRoles')
              this.$router.push({ name: "home" });
            }
          })
          .catch(err => {
            this.loading = false;
            if (err.response.status === 403) {
              this.$toast("Usuario desactivado.", {
                color: "error",
                x: "center",
                y: "top",
                icon: "mdi-information",
                timeout: 0,
                showClose: true,
                closeText: "Cerrar"
              });
            } else {
              this.$toast("Usuario o contraseña incorrectos.", {
                color: "error",
                x: "center",
                y: "top",
                icon: "mdi-information",
                timeout: 0,
                showClose: true,
                closeText: "Cerrar"
              });
            }
          });
      }
    },
    checkPass(v) {
      if (!v) return "Requerido";
      if (v !== this.password_new) return "Contraseña diferente";
      return true;
    },
    submitUpdate(e) {
      e.preventDefault();
      if (this.$refs.update.validate()) {
        this.loading = true;
        let obj = {
          username: this.username,
          password_old: this.password,
          password: this.password_new,
          password_confirmation: this.password_new_retype
        };
        AuthClient.resetPassword(obj)
          .then(resp => {
            this.loading = false;
            if (resp.data.token !== undefined) {
              AuthClient.saveUser({
                token: resp.data.token
              });
              this.$router.push("/principal");
            }
          })
          .catch(err => {
            window.err = err;
            this.loading = false;
            this.errorLogin = 1;
            if (err.response.status === 403) {
              this.errorLogin = 2;
            }
          });
      }
    }
  }
};
</script>
